import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

export default props => {
    const { money } = props

    const global = useSelector(state => state.global)
    const { config, country } = global

    useEffect(() => {
        let paypalScript = document.getElementById('paypal-message-script')
        const head = document.getElementsByTagName('head')[0]
        if (!paypalScript) {
            const script = document.createElement('script')
            script.id = 'paypal-message-script'
            script.type = 'text/javascript'
            script.src = `https://www.paypal.com/sdk/js?client-id=${config?.paypal?.clientId}&currency=${money?.currency}${config.env==='sandbox'?(`&buyer-country=${country}`):''}&components=messages`
            script.async = true
            head.appendChild(script)
        }
    }, [])

    return <div
        data-pp-message
        data-pp-placement={'product'}
        data-pp-amount={money?.amount}
        data-pp-buyercountry={country}
    ></div>
}